// Mock data for 可乐漫画
export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  cover: string;
  category: string;
  categorySlug: string;
  tags: string[];
  description: string;
  rating: number;
  views: number;
  chapters: ComicChapter[];
  status: '连载中' | '已完结';
  updatedAt: string;
  createdAt: string;
}

export const categories = [
  { name: '韩漫', slug: 'korean', icon: 'ri-kakao-talk-fill', description: '韩国漫画，画风精致，剧情引人入胜' },
  { name: '日漫', slug: 'japanese', icon: 'ri-sun-fill', description: '日本漫画，经典风格，种类丰富' },
  { name: '国漫', slug: 'chinese', icon: 'ri-china-railway-fill', description: '国产漫画，国风美学，日渐崛起' },
];

export const comics: Comic[] = [
  {
    id: '1',
    title: '我独自升级',
    author: 'Chugong / DUBU',
    cover: 'https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20manhwa%20style%20illustration%20of%20a%20powerful%20male%20warrior%20with%20dark%20hair%20and%20glowing%20eyes%2C%20wearing%20a%20black%20coat%2C%20holding%20a%20dagger%2C%20dramatic%20lighting%2C%20action%20pose%2C%20dark%20atmospheric%20background%20with%20blue%20flames%2C%20anime%20style%2C%20high%20quality%20digital%20art&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    category: '韩漫',
    categorySlug: 'korean',
    tags: ['热血', '奇幻', '战斗'],
    description: '十年前，世界各地出现了连接异次元的"门"，觉醒者们为了讨伐门内的怪物而战斗。被称为"人类最弱兵器"的E级猎人成振宇，在一次D级地下城遭遇双重门事件后濒临死亡，却意外获得了神秘的"系统"，成为唯一能够"升级"的猎人。从此，他踏上了从最弱到最强的逆袭之路。',
    rating: 9.6,
    views: 12800000,
    chapters: Array.from({ length: 179 }, (_, i) => ({
      id: `ch1-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(Math.floor(Math.random() * 8) + 1).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
    })),
    status: '已完结',
    updatedAt: '2026-08-01',
    createdAt: '2023-03-15',
  },
  {
    id: '2',
    title: '全知读者视角',
    author: 'sing N song / Sleepy-C',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20illustration%20of%20a%20young%20man%20with%20glasses%20and%20dark%20hair%2C%20holding%20a%20book%20with%20glowing%20pages%2C%20intelligent%20expression%2C%20wearing%20a%20white%20shirt%2C%20mysterious%20atmosphere%2C%20surrounded%20by%20floating%20text%20and%20constellations%2C%20anime%20style%2C%20high%20quality&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    category: '韩漫',
    categorySlug: 'korean',
    tags: ['奇幻', '生存', '系统'],
    description: '独居生金独子，是唯一一个读完了连载十年小说《生存的三种方法》的读者。当小说完结的那天，世界突然变成了小说中的场景，末日降临。作为唯一知道结局的人，金独子凭借对剧情的了解，在这个残酷的世界中开始了他的生存之路。',
    rating: 9.5,
    views: 10500000,
    chapters: Array.from({ length: 210 }, (_, i) => ({
      id: `ch2-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(Math.floor(Math.random() * 8) + 1).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
    })),
    status: '连载中',
    updatedAt: '2026-08-03',
    createdAt: '2023-06-20',
  },
  {
    id: '3',
    title: '剑尊归来',
    author: 'LIKE STUDIO',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20illustration%20of%20a%20handsome%20swordsman%20with%20long%20white%20hair%2C%20wearing%20traditional%20martial%20arts%20robes%2C%20holding%20a%20glowing%20sword%2C%20elegant%20and%20powerful%20stance%2C%20cherry%20blossoms%20falling%2C%20mountain%20background%2C%20anime%20style%2C%20high%20quality&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    category: '韩漫',
    categorySlug: 'korean',
    tags: ['武侠', '重生', '热血'],
    description: '天下第一剑尊白宇辰，在与魔教教主的大战中陨落，却意外重生回到了少年时代。带着前世的记忆和武学造诣，他决定重写命运，守护那些曾经失去的人。剑尊归来，天下再起风云！',
    rating: 9.3,
    views: 8900000,
    chapters: Array.from({ length: 156 }, (_, i) => ({
      id: `ch3-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(Math.floor(Math.random() * 8) + 1).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
    })),
    status: '连载中',
    updatedAt: '2026-08-02',
    createdAt: '2024-01-10',
  },
  {
    id: '4',
    title: '咒术回战',
    author: '芥见下下',
    cover: 'https://readdy.ai/api/search-image?query=A%20Japanese%20manga%20style%20illustration%20of%20a%20young%20man%20with%20spiky%20pink%20hair%2C%20wearing%20a%20dark%20school%20uniform%2C%20surrounded%20by%20cursed%20energy%20effects%2C%20intense%20battle%20expression%2C%20dark%20supernatural%20theme%2C%20anime%20art%20style%2C%20high%20quality&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    category: '日漫',
    categorySlug: 'japanese',
    tags: ['热血', '战斗', '校园'],
    description: '高中生虎杖悠仁，在偶然的机会下吞下了诅咒之王两面宿傩的手指，成为了宿傩的容器。从此他加入了东京都立咒术高等专门学校，与伙伴们一起对抗诅咒，保护人类。',
    rating: 9.4,
    views: 15600000,
    chapters: Array.from({ length: 260 }, (_, i) => ({
      id: `ch4-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(Math.floor(Math.random() * 8) + 1).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
    })),
    status: '连载中',
    updatedAt: '2026-08-03',
    createdAt: '2018-03-05',
  },
  {
    id: '5',
    title: '间谍过家家',
    author: '远藤达哉',
    cover: 'https://readdy.ai/api/search-image?query=A%20Japanese%20manga%20style%20illustration%20of%20a%20family%20of%20three%2C%20a%20man%20in%20a%20suit%20with%20a%20pistol%2C%20a%20woman%20with%20red%20hair%20in%20a%20dress%2C%20and%20a%20little%20girl%20with%20pink%20hair%20holding%20a%20stuffed%20toy%2C%20spy%20theme%2C%20warm%20family%20atmosphere%2C%20anime%20style%2C%20high%20quality&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    category: '日漫',
    categorySlug: 'japanese',
    tags: ['喜剧', '家庭', '间谍'],
    description: '为了执行任务，西国最强间谍"黄昏"需要组建一个临时家庭。他收养了能读心的超能力少女阿尼亚，与身份神秘的杀手约尔假结婚。三人各怀秘密，却组成了一个温暖而有趣的"家庭"。',
    rating: 9.7,
    views: 18200000,
    chapters: Array.from({ length: 98 }, (_, i) => ({
      id: `ch5-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(Math.floor(Math.random() * 8) + 1).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
    })),
    status: '连载中',
    updatedAt: '2026-08-03',
    createdAt: '2019-03-25',
  },
  {
    id: '6',
    title: '葬送的芙莉莲',
    author: '山田钟人 / 阿部司',
    cover: 'https://readdy.ai/api/search-image?query=A%20Japanese%20manga%20style%20illustration%20of%20a%20beautiful%20female%20elf%20mage%20with%20long%20silver%20hair%2C%20wearing%20a%20white%20robe%2C%20holding%20a%20magical%20staff%2C%20gentle%20and%20melancholic%20expression%2C%20fantasy%20world%20background%20with%20flowers%2C%20anime%20style%2C%20high%20quality%20art&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    category: '日漫',
    categorySlug: 'japanese',
    tags: ['奇幻', '冒险', '治愈'],
    description: '打倒魔王的勇者一行人，在十年冒险结束后各自散去。身为精灵的魔法使芙莉莲，拥有远超人类的寿命。五十年后，当她再次见到昔日的伙伴时，才发现人类生命的短暂。为了理解人类的情感，她踏上了新的旅程。',
    rating: 9.8,
    views: 9500000,
    chapters: Array.from({ length: 135 }, (_, i) => ({
      id: `ch6-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(Math.floor(Math.random() * 8) + 1).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
    })),
    status: '连载中',
    updatedAt: '2026-08-02',
    createdAt: '2020-04-28',
  },
  {
    id: '7',
    title: '一人之下',
    author: '米二',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20style%20illustration%20of%20a%20young%20man%20with%20short%20black%20hair%2C%20wearing%20a%20casual%20jacket%2C%20surrounded%20by%20taoist%20energy%20and%20mystical%20symbols%2C%20martial%20arts%20vibe%2C%20modern%20urban%20setting%20with%20traditional%20elements%2C%20anime%20style%2C%20high%20quality&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    category: '国漫',
    categorySlug: 'chinese',
    tags: ['异能', '热血', '道家'],
    description: '普通大学生张楚岚，因爷爷的坟墓被盗而卷入异人世界。他发现自己拥有远超常人的异能——炁体源流。在这个隐藏于现代社会之下的异能世界中，各路人马纷纷登场，一场围绕八奇技的纷争就此展开。',
    rating: 9.5,
    views: 11200000,
    chapters: Array.from({ length: 680 }, (_, i) => ({
      id: `ch7-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(Math.floor(Math.random() * 8) + 1).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
    })),
    status: '连载中',
    updatedAt: '2026-08-03',
    createdAt: '2015-02-26',
  },
  {
    id: '8',
    title: '狐妖小红娘',
    author: '小新',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20style%20illustration%20of%20a%20beautiful%20fox%20spirit%20girl%20with%20red%20hair%20and%20fox%20ears%2C%20wearing%20traditional%20red%20Chinese%20dress%2C%20holding%20a%20magic%20mirror%2C%20romantic%20and%20dreamy%20atmosphere%2C%20ancient%20Chinese%20style%20background%2C%20anime%20style%2C%20high%20quality&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    category: '国漫',
    categorySlug: 'chinese',
    tags: ['爱情', '奇幻', '古风'],
    description: '在人妖共存的幻想世界中，狐妖涂山苏苏以红娘为职业，为前世恋人们牵线续缘。她与道士白月初的相遇，揭开了一段跨越千年的爱恨纠葛。今生来世，我愿与你再续前缘。',
    rating: 9.3,
    views: 9800000,
    chapters: Array.from({ length: 520 }, (_, i) => ({
      id: `ch8-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(Math.floor(Math.random() * 8) + 1).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
    })),
    status: '连载中',
    updatedAt: '2026-08-01',
    createdAt: '2012-06-01',
  },
  {
    id: '9',
    title: '镖人',
    author: '许先哲',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20style%20illustration%20of%20a%20fierce%20swordsman%20with%20a%20scarred%20face%2C%20wearing%20worn%20leather%20armor%2C%20holding%20a%20curved%20blade%2C%20riding%20a%20horse%20in%20the%20desert%2C%20rough%20and%20realistic%20style%2C%20Tang%20dynasty%20aesthetic%2C%20anime%20style%2C%20high%20quality&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    category: '国漫',
    categorySlug: 'chinese',
    tags: ['武侠', '历史', '热血'],
    description: '大业三年，隋朝末年。身手不凡的镖客刀马，带着年幼的孩子行走于西域大漠之中，接了一趟护送神秘人物前往长安的镖。一路上暗流涌动，各方势力交织，一场改变天下格局的冒险就此展开。',
    rating: 9.6,
    views: 7600000,
    chapters: Array.from({ length: 115 }, (_, i) => ({
      id: `ch9-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(Math.floor(Math.random() * 8) + 1).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
    })),
    status: '连载中',
    updatedAt: '2026-07-30',
    createdAt: '2015-07-01',
  },
  {
    id: '10',
    title: '我培养的S级们',
    author: 'SERO / Geulim',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20illustration%20of%20a%20handsome%20man%20with%20silver%20hair%20and%20glowing%20blue%20eyes%2C%20wearing%20a%20futuristic%20black%20combat%20suit%2C%20surrounded%20by%20holographic%20displays%2C%20dungeon%20hunter%20theme%2C%20sci-fi%20and%20fantasy%20blend%2C%20anime%20style%2C%20high%20quality&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    category: '韩漫',
    categorySlug: 'korean',
    tags: ['系统', '猎人', '养成'],
    description: '在猎人横行的世界里，F级猎人韩宥真意外获得了"培养系统"。他发现自己可以培养其他猎人，帮助他们突破等级上限。从一个被瞧不起的最弱猎人，到培养出S级猎人的传奇导师，他的逆袭之路就此开启。',
    rating: 9.2,
    views: 7200000,
    chapters: Array.from({ length: 145 }, (_, i) => ({
      id: `ch10-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(Math.floor(Math.random() * 8) + 1).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
    })),
    status: '连载中',
    updatedAt: '2026-08-03',
    createdAt: '2024-03-01',
  },
  {
    id: '11',
    title: '某天成为公主',
    author: 'Plutus / Spoon',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20illustration%20of%20a%20beautiful%20princess%20with%20long%20blonde%20hair%20and%20blue%20eyes%2C%20wearing%20an%20elegant%20pink%20royal%20dress%2C%20standing%20in%20a%20palace%20garden%2C%20romantic%20fantasy%20theme%2C%20sparkling%20magical%20effects%2C%20anime%20style%2C%20high%20quality&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    category: '韩漫',
    categorySlug: 'korean',
    tags: ['穿越', '恋爱', '宫廷'],
    description: '一觉醒来，我变成了小说中注定要被亲生父亲杀死的悲催公主！为了活命，我决定远离那个冷酷的皇帝父亲。但为什么，原本对我漠不关心的父皇，突然开始关注我了？这个剧情发展和小说完全不一样啊！',
    rating: 9.4,
    views: 8500000,
    chapters: Array.from({ length: 125 }, (_, i) => ({
      id: `ch11-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(Math.floor(Math.random() * 8) + 1).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
    })),
    status: '已完结',
    updatedAt: '2026-06-15',
    createdAt: '2022-09-01',
  },
  {
    id: '12',
    title: '进击的巨人',
    author: '谏山创',
    cover: 'https://readdy.ai/api/search-image?query=A%20Japanese%20manga%20style%20illustration%20of%20a%20giant%20titan%20with%20muscular%20body%20and%20no%20skin%2C%20steam%20rising%2C%20behind%20a%20massive%20wall%2C%20soldiers%20with%20swords%20in%20the%20foreground%2C%20dark%20and%20apocalyptic%20atmosphere%2C%20anime%20style%2C%20high%20quality&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    category: '日漫',
    categorySlug: 'japanese',
    tags: ['末世', '战斗', '悬疑'],
    description: '107年前，人类的天敌"巨人"突然出现，幸存的人类逃到了被巨大墙壁包围的城镇中。少年艾伦·耶格尔目睹母亲被巨人吞噬，发誓要消灭所有巨人。他加入了调查兵团，却逐渐发现了这个世界的惊人真相。',
    rating: 9.5,
    views: 20000000,
    chapters: Array.from({ length: 139 }, (_, i) => ({
      id: `ch12-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(Math.floor(Math.random() * 8) + 1).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
    })),
    status: '已完结',
    updatedAt: '2026-04-09',
    createdAt: '2009-09-09',
  },
];

export const bannerComics = ['1', '4', '7'];

export function getComicsByCategory(slug: string): Comic[] {
  return comics.filter(c => c.categorySlug === slug);
}

export function getComicById(id: string): Comic | undefined {
  return comics.find(c => c.id === id);
}

export function getLatestComics(limit: number = 10): Comic[] {
  return [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, limit);
}

export function getPopularComics(limit: number = 10): Comic[] {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, limit);
}

export function getRecommendedComics(excludeId: string, limit: number = 6): Comic[] {
  return comics.filter(c => c.id !== excludeId).slice(0, limit);
}